export default "__VITE_ASSET__C2r12kwT__"